module.exports = __webpack_public_path__ + "static/ActaAgate-Bold-1ca3b16d0ad4a3e3a5b78c74dc34fc81.woff";